const LOCAL = /^(.*\.vm\.cinch\.io|localhost|[0-9.]+)(:[0-9]+)?$/gim;
const DEV = ["ops.dev.aws.cinch.io"];
const PROD = ["ops.cinch.io"];

/**
 * Constants used throughout the application.
 * @type {Object} - The CONSTANTS object to help reuse some values throughout the application and maintain consistency.
 *
 * @property {Object} URL - The URL constants; ADD_TEMPLATE_MAIL, LIST_TEMPLATE
 * @property {Object} MODES - The modes constants; TEMPLATE: CREATE, PREVIEW, PUBLISH. Used in the template editor.
 * @property {string[]} READ_ONLY_CUSTOMER_FIELDS - The array of fields that are read-only in the customer editor.
 * @property {string[]} PROVINCES_CANADA - The array of Canadian provinces. eh!
 * @property {Object[]} TIMEZONES - The array of timezones. Used in the timezone dropdown.
 * @property {string} ENV - The environment the application is running in. LOCAL, DEV, PROD.
 */

const CONSTANTS = {
  URL: {
    ADD_TEMPLATE_MAIL: "/templates/print/add",
    LIST_TEMPLATE: "/templates",
  },
  MODES: {
    TEMPLATE: {
      CREATE: "CREATE",
      PREVIEW: "PREVIEW",
      PUBLISHV: "PUBLISH",
    },
  },

  READ_ONLY_CUSTOMER_FIELDS: [
    "id",
    "company_id",
    "created_when",
    "updated_when",
    "deleted_when",
    "entity_ref",
    "entity_source",
    "entity_number",
    "index_rank",
    "customer_value",
    "customer_value_segment",
    "visit_trend_days",
    "predicted_return_date",
    "predicted_visit_next_12_months",
    "predicted_spend_next_12_months",
    "product_preferences",
    "recommended_products",
    "pricing_sensitivity",
    "last_transaction_when",
    "first_transaction_when",
    "appended_data__",
    "stat_last_location_id",
    "stat_last_location__name",
    "stat_last_location__address1",
    "stat_last_location__city",
    "stat_last_location__state",
    "stat_last_location__zip_code",
    "stat_last_location__phone",
    "stat_last_location__entity_ref",
  ],

  /**
   * All Canadian province abbreviations.
   * @type {string[]}
   */
  PROVINCES_CANADA: [
    "AB",
    "BC",
    "MB",
    "NB",
    "NL",
    "NS",
    "NT",
    "NU",
    "ON",
    "PE",
    "QC",
    "SK",
    "YT",
  ],

  /**
   * A list of timezones
   * @type {Object[]} The object format is: {id, label}
   */
  TIMEZONES: [
    { id: "America/New_York", label: "Eastern Standard Time", abbr: "EST" },
    { id: "America/Chicago", label: "Central Standard Time", abbr: "CST" },
    { id: "America/Denver", label: "Mountain Standard Time", abbr: "MST" },
    { id: "America/Los_Angeles", label: "Pacific Standard Time", abbr: "PST" },
    { id: "America/Anchorage", label: "Alaska Standard Time", abbr: "AKST" },
    { id: "Pacific/Honolulu", label: "Hawaii Standard Time", abbr: "HST" },
    { id: "Etc/GMT+4", label: "Atlantic Standard Time", abbr: "AST" },
    { id: "Etc/GMT+7", label: "Arizona", abbr: "AZ" },
  ],

  ENV: window.location.host.match(LOCAL)
    ? "LOCAL"
    : DEV.includes(window.location.host)
    ? "DEV"
    : "PROD",

  // Base URLs for cross-domain deep links from the employee-operations UI
  // into the customer-facing FE (voice-agents page, call history,
  // employee-portal contract detail) and Stripe's dashboard. Mirror the
  // ENV resolution above — keep these in lock-step when adding new envs.
  CUSTOMER_FE_BASE: window.location.host.match(LOCAL)
    ? "https://fe.krichey.vm.cinch.io"
    : DEV.includes(window.location.host)
    ? "https://marketing-dev.cinch.io"
    : "https://marketing.cinch.io",

  STRIPE_DASHBOARD_BASE: window.location.host.match(LOCAL) || DEV.includes(window.location.host)
    ? "https://dashboard.stripe.com/test"
    : "https://dashboard.stripe.com",
};

export default CONSTANTS;
